import React from "react";

// export const MyCommandCell = props => {
//   const { dataItem } = props;
//   const inEdit = dataItem[props.editField];
//   const isNewItem = dataItem.ProductID === undefined;

//   return inEdit ? (
//     <td className="k-command-cell">
//       <button
//         className="k-button k-grid-save-command gridbutton"
//         onClick={() => (isNewItem ? props.add(dataItem) : props.update(dataItem))}
//       >
//         {isNewItem ? <i class="fas fa-check"></i> : <i class="fas fa-redo"></i>}
//       </button>
//       <button
//         className="k-button k-grid-cancel-command gridbutton"
//         onClick={() => (isNewItem ? props.discard(dataItem) : props.cancel(dataItem))}
//       >
//         {isNewItem ? <i class="fas fa-times"></i> : <i class="fas fa-times"></i>}
//       </button>
//     </td>
//   ) : (
//     <td className="k-command-cell">
//       <button
//         className="k-primary k-button k-grid-edit-command gridbutton"
//         onClick={() => props.edit(dataItem)}
//       >
//        <i class="fas fa-edit"></i>
//       </button>
//       <button
//         className="k-button k-grid-remove-command gridbutton"
//         onClick={() => props.remove(dataItem)
//         }
//       >
//         <i class="fas fa-trash"></i>
//       </button>
//     </td>
//   );
// };



// import * as React from "react";
export const MyCommandCell = props => {
  const {
    dataItem
  } = props;
  const inEdit = dataItem[props.editField];
  const isNewItem = dataItem.ProductID === undefined;
  return inEdit ? <td className="k-command-cell">
      <button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base k-grid-save-command gridbutton" onClick={() => isNewItem ? props.add(dataItem) : props.update(dataItem)}>
        {isNewItem ? <i className="fas fa-check"></i> : <i className="fas fa-redo"></i>}
      </button>
      <button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base k-grid-cancel-command gridbutton" onClick={() => isNewItem ? props.discard(dataItem) : props.cancel(dataItem)}>
        {isNewItem ? <i className="fas fa-times"></i> : <i className="fas fa-times"></i>}
      </button>
    </td> : <td className="k-command-cell">
      <button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary k-grid-edit-command gridbutton" onClick={() => props.edit(dataItem)}>
      <i className="fas fa-edit"></i>
      </button>
      <button className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base k-grid-remove-command gridbutton" onClick={() => props.remove(dataItem)}>
      <i className="fas fa-trash"></i>
      </button>
    </td>;
};